import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  AdditionalCtasWrapper,
  Title,
  ContentWrapper,
  ImageContainer,
  SubTitle,
  Cta,
  ImageForCta,
  TextForCta,
  AdditionaBlock,
} from './AdditionalCtas.styles';
import { selectAppConfig } from '../../redux/appConfigReducer';

const AdditionalCtas: React.FC = () => {
  const { marketType } = useSelector(selectAppConfig);
  const { t, i18n } = useTranslation();
  const lang = i18n.resolvedLanguage;

  const contactDealerImage =
    'https://nar.media.audi.com/is/image/audinar/nemo/ca/NoMo/collaboration/wormwod/additional-cta/contact-dealer.png';
  const configuratorImage =
    'https://nar.media.audi.com/is/image/audinar/nemo/ca/NoMo/collaboration/wormwod/additional-cta/calculate-payments.png';

  const urlBuildPage = useMemo(() => {
    if (marketType === 'CAN') return `https://www.audi.ca/${lang}/models/`;
    return `https://www.audiusa.com/en/models/`;
  }, [lang, marketType]);

  return (
    <AdditionalCtasWrapper>
      <Title>{t('vlp.additionalCtas.header')}</Title>
      <ContentWrapper>
        <AdditionaBlock>
          <ImageContainer>
            <ImageForCta src={contactDealerImage} alt={t('vlp.additionalCtas.contactDealer')} />
          </ImageContainer>
          <SubTitle>{t('vlp.additionalCtas.contactDealer')}</SubTitle>
          <TextForCta>{t('vlp.additionalCtas.contactText')}</TextForCta>
          <Cta href="#contact_general">{t('vlp.additionalCtas.contactCTA')}</Cta>
        </AdditionaBlock>
        <AdditionaBlock>
          <ImageContainer>
            <ImageForCta src={configuratorImage} alt={t('vlp.additionalCtas.build')} />
          </ImageContainer>
          <SubTitle>{t('vlp.additionalCtas.build')}</SubTitle>
          <TextForCta>{t('vlp.additionalCtas.buildText')}</TextForCta>
          <Cta href={urlBuildPage}>{t('vlp.additionalCtas.buildCTA')}</Cta>
        </AdditionaBlock>
      </ContentWrapper>
    </AdditionalCtasWrapper>
  );
};

export default AdditionalCtas;
